export const runpod_permission = {
    required_permission :["view_runpodtips","add_runpodtips","change_runpodtips",'view_tipsettings','add_tipsettings','change_tipsettings','delete_tipsettings'] 
}